export default "__VITE_ASSET__26ceb31d__"